import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Library, OPTIONS } from '../library';

@Injectable({
  providedIn: 'root'
})
export class PayrollProcessService {

  constructor(private http: HttpClient) { }

  createUpdatePayrollProcess(form: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'payroll-process/save_update_payroll_process', form, OPTIONS);
  }

  getPayrollProcesses() {
    return this.http.get<any>(Library.API_ENDPOINT + 'payroll-process/get_payrollProcess', OPTIONS);
  }

   getPayrollProcessesClose() {
    return this.http.get<any>(Library.API_ENDPOINT + 'payroll-process/get_payrollProcess_close', OPTIONS);
  }

  deleteProcess(id: number) {
    return this.http.post<any>(Library.API_ENDPOINT + `payroll-process/delete_payroll_process/${id}`, OPTIONS);
  }

  getDocStatuses() {
    return this.http.get<any>(Library.API_ENDPOINT + 'payroll-process/get_doc_status', OPTIONS);
  }

  getCommonDocStatuses() {
    return this.http.get<any>(Library.API_ENDPOINT + 'common/get_doc_status', OPTIONS);
  }

  docActionProcess(status: any, id: number) {
    return this.http.post<any>(Library.API_ENDPOINT + `payroll-process/payroll_process_doc_action/${id}/${status}`, OPTIONS);
  }

  docActionPayroll(status: any, id: number) {
    return this.http.post<any>(Library.API_ENDPOINT + `payroll-process/payroll_doc_action/${id}/${status}`, OPTIONS);
  }
}
